const config = {
  CHALLENGE_END_DATE: "2023-02-04T00:00:00Z",
};

module.exports = config;
